module.exports = __webpack_public_path__ + "media/images/plans/e-photo_location/e-photo_location-3-e5ba0961fa3d52ee2a7ffc6fd8ff6ebf.png";